import { useStateContext } from '../modules/stateContext';

export const useUnder13ErrorMessageId = () => {
    const {
        skipAgeBracketScreen,
        suppressRegisterLinks,
        featureToggles: { updatedUnder13ErrorMessage },
    } = useStateContext();

    const skipAgeBracketScreenParam = skipAgeBracketScreen === 'true';
    const suppressRegisterLinksParam = suppressRegisterLinks === 'true';

    if (updatedUnder13ErrorMessage) {
        if (skipAgeBracketScreenParam || suppressRegisterLinksParam) {
            return 'validation.updated.dateOfBirth.long.under13';
        }
    }

    return 'validation.dateOfBirth.long.under13';
};
